import React from 'react';
import { FeeSection } from './FeeSection';
import { IFeeSection } from './organizeFees';

export interface IFeeSectionsProps {
  feeSections: IFeeSection[];
}

export const FeeSections: React.FC<IFeeSectionsProps> = ({ feeSections }) => (
  <>
    {feeSections.map((t) => (
      <FeeSection key={t.sectionDefinition.sectionLetter + t.sectionDefinition.sectionDescription} feeSection={t} />
    ))}
  </>
);
